<div
  class="pt-[70px] h-[100vh -60px] m-auto flex flex-col justify-center items-center gap-[15px]">
  <div class="w-40 desktop:w-auto">
    <img src="icons/message_time.svg" width="275px" height="260px" alt="" />
  </div>
  <div class="text-center max-w-[350px] h-[110px] flex flex-col gap-[15px]">
    <h3 class="text-xl text-info-600 font-bold">¿Seguís ahí?</h3>
    <p class="text-sm text-primary-800 font-medium">
      Han pasado varios minutos sin actividad y puede ser que los resultados se
      hayan modificado. Deberás actualizar la búsqueda.
    </p>
  </div>
  <div class="flex gap-[15px]">
    <app-button
      color="Secondary"
      text="ACTUALIZAR LA BÚSQUEDA"
      size="Large"
      (buttonClick)="onClick($event)" />
  </div>
</div>
